import text from '../text.json'
import {Formik} from 'formik'
import {Input as CustomInput} from '../../../components/core/input'
import Input from 'react-phone-number-input/input'
import {isValidPhoneNumber} from 'react-phone-number-input'
import ButtonLoader from '../../../components/core/button/ButtonLoader'
import {SimpleBlueButton} from '../../../components/core/button'
import {useState} from 'react'
import {useDispatch} from 'react-redux'
import {updateChannel} from '../../../stores/customer-settings'

const UpdateSmsChannel = ({data, setModalData, customerId, isDarkMode}) => {
    const [buttonIsDisabled, setButtonIsDisabled] = useState(true)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [phoneNumber, setPhoneNumber] = useState('')
    const dispatch = useDispatch()

    const initialFormValues = {
        value: '',
        priority: data?.channel?.priority,
        type: data?.channel?.type
    }

    const updateNotificationChannel = async(values, {setFieldError}) => {
        setIsSubmitting(true)
        const fetchedData = await dispatch(updateChannel(false, customerId, {...values, value: phoneNumber}, setFieldError))
        if (fetchedData) {
            setIsSubmitting(false)
            closePopup()
            setModalData(prev => ({
                ...prev,
                status: true,
                codeModal: true,
                value: phoneNumber,
                type: data?.channel?.type,
                channel: data?.channel
            }))
        }
        setIsSubmitting(false)
    }

    const validateNumber = () => {
        if (!isValidPhoneNumber(phoneNumber)) {
            setButtonIsDisabled(true)
            return text.number_is_not_valid
        }
        return setButtonIsDisabled(false)
    }

    const closePopup = () => {
        setPhoneNumber('')
        setModalData({})
    }

    return (
        <Formik initialValues={initialFormValues}
            enableReinitialize={true}
            onSubmit={updateNotificationChannel}
            validateOnBlur={false}
            validateOnChange={false}>
            {({errors, handleSubmit, setErrors}) => (
                <form onSubmit={handleSubmit} className="modal-body">
                    <CustomInput
                        customInput={
                            <Input
                                className={`simple-input ${isDarkMode ? 'dark' : ''}`}
                                placeholder={text.phone_number}
                                name='value'
                                value={phoneNumber}
                                onChange={e => {
                                    setPhoneNumber(e)
                                    setErrors({})
                                }}
                            />
                        }
                        infoText={text.sms_info}
                        error={(phoneNumber?.length > 0 && validateNumber()) || errors.value}
                    />
                    <SimpleBlueButton
                        disabled={buttonIsDisabled}
                        type="submit">
                        {isSubmitting && <ButtonLoader/>}
                        {text.next}
                    </SimpleBlueButton>
                </form>
            )}
        </Formik>
    )
}

export default UpdateSmsChannel
